export const getLangToLoadByLocale = (lang) => (lang === 'ja' ? 'ja' : 'en')

export const filterPublic = (items) =>
  items.filter((item) => item.Visibility === 'Public')
